export const HELP_SCREEN = {
  HELP_SECTION: 'Help Section',
  USER_GUIDE: 'User Guide',
  HERE: 'here',
  TRAINING_VIDEO: 'Training Video',
  IDENTIFY_ISSUES:
    'If you identify any issues please send a description including screenshots or video to the support team:',
};
